module.exports = __webpack_public_path__ + "wxbtit.554a7c26.gif";